"use client";

import type { TextColor } from "@homeinstead/schemas";
import type { CarePlusInquiryFormData } from "./carePlusInquiry.schema";

import { cn } from "@homeinstead/ui";
import { Controller, useFormContext } from "react-hook-form";
import { RecipientOptions } from "~www/components/LeadForm/CareSeeker/shared/form-options";
import { InquiryStepHeading } from "~www/components/LeadForm/Inquiry";
import { CarePlusRecipientButton } from "./CarePlusRecipientButton";

const iconColorMap: Record<number, string> = {
  0: "fill-[#EF5574] group-hover:fill-new-beginnings-base",
  1: "fill-[#82AFD7] group-hover:fill-new-beginnings-base",
  2: "fill-[#859A5E] group-hover:fill-new-beginnings-base",
  3: "fill-new-beginnings-base group-hover:fill-new-beginnings-base",
};

type CarePlusRecipientStepProps = {
  nextStep: () => void;
  textColor?: TextColor;
};

function CarePlusRecipientStep({
  nextStep,
  textColor,
}: CarePlusRecipientStepProps) {
  const { control } = useFormContext<CarePlusInquiryFormData>();

  return (
    <div className="flex w-full flex-col items-start gap-4 md:max-w-[440px]">
      <InquiryStepHeading className="mb-4 w-full" textColor={textColor}>
        Who is Care+ for?
      </InquiryStepHeading>
      <Controller
        control={control}
        name="careFor"
        render={({ field }) => (
          <div className="flex w-full flex-col gap-4 md:w-[250px] md:gap-3">
            <input type="hidden" {...field} />
            {RecipientOptions.map((option, index) => {
              const Icon = option.icon;
              const optionFill = iconColorMap[index];
              return (
                <CarePlusRecipientButton
                  careRecipient={option.value}
                  className="group flex h-12 w-full justify-start gap-4 rounded-full px-6 font-semibold md:w-auto"
                  field={field}
                  key={option.value}
                  nextStepCallback={nextStep}
                >
                  <Icon className={cn("size-6", optionFill)} />
                  <span>{option.label}</span>
                </CarePlusRecipientButton>
              );
            })}
          </div>
        )}
      />
    </div>
  );
}

export { CarePlusRecipientStep };
